import { render, staticRenderFns } from "./GPTPublicFileUpload.vue?vue&type=template&id=bdcc3dc8&scoped=true"
import script from "./GPTPublicFileUpload.vue?vue&type=script&lang=js"
export * from "./GPTPublicFileUpload.vue?vue&type=script&lang=js"
import style0 from "./GPTPublicFileUpload.vue?vue&type=style&index=0&id=bdcc3dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc3dc8",
  null
  
)

export default component.exports